export function isNativeApp(): boolean {
  return (window as any).PencilSpacesFrontEnd?.isNativeApp === true;
}
